document.addEventListener('DOMContentLoaded', function () {

  // ── Layout toggle ─────────────────────────────────────────────────────
  document.querySelectorAll('.fw-b2b-layout-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.fw-b2b-layout-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const list = document.getElementById('fwB2bProductList');
      if (list) list.dataset.layout = this.dataset.layout;
    });
  });

  // ── Select all ────────────────────────────────────────────────────────
  const selectAll = document.getElementById('fwB2bSelectAll');
  if (selectAll) {
    selectAll.addEventListener('change', () => {
      document.querySelectorAll('.fw-b2b-row-check').forEach(cb => cb.checked = selectAll.checked);
    });
  }

  // ── Sort ──────────────────────────────────────────────────────────────
  window.fwB2bApplySort = function (value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    window.location.href = url.toString();
  };

  // ── Mobile-Filter-Button: öffnet den <facet-filters>-Drawer ─────────────
  document.getElementById('fwB2bMobileFilterBtn')?.addEventListener('click', function () {
    const facets = document.querySelector('.fw-b2b-sidebar facet-filters');
    if (facets && typeof facets.open === 'function') {
      facets.open(this);
    }
  });

  // ── Sort-Select in den Filter-Drawer injizieren (nur Mobile) ────────────
  // Auf Mobile soll die Sortierung nicht in der Toolbar stehen, sondern oben
  // im Filter-Drawer (Button heißt deshalb auch „Filter & Sortierung").
  // Wir klonen das Original-Select, sodass beide Selects synchron bleiben.
  (function injectDrawerSort() {
    const original = document.getElementById('fwB2bSort');
    if (!original) return;
    const drawerContent = document.querySelector('.fw-b2b-sidebar .drawer__content')
      || document.querySelector('.fw-b2b-sidebar facet-filters');
    if (!drawerContent || drawerContent.querySelector('.fw-b2b-drawer-sort')) return;

    const wrap = document.createElement('div');
    wrap.className = 'fw-b2b-drawer-sort';
    wrap.innerHTML = '<label class="fw-b2b-drawer-sort__label" for="fwB2bSortDrawer">Sortieren</label>';

    const select = original.cloneNode(true);
    select.id = 'fwB2bSortDrawer';
    select.removeAttribute('onchange');
    select.addEventListener('change', function () {
      window.fwB2bApplySort(this.value);
    });
    wrap.appendChild(select);

    // Vor das erste Kind des Drawer-Contents einfügen (oberhalb der Filter)
    drawerContent.insertBefore(wrap, drawerContent.firstChild);
  })();

  // ── Cart-Panel Collapse-Toggle (nur Mobile aktiv via CSS) ──────────────
  // Header ist clickable; "Leeren"-Button stoppt Propagation, damit er nicht togglet.
  const cartPanel = document.getElementById('fwB2bCartPanel');
  const panelHeader = document.getElementById('fwB2bPanelHeader');
  if (cartPanel && panelHeader) {
    panelHeader.addEventListener('click', function (e) {
      // Klicks auf den Leeren-Button sollen das Panel nicht togglen
      if (e.target.closest('.fw-b2b-panel-header__clear')) return;
      const isOpen = cartPanel.getAttribute('aria-expanded') === 'true';
      cartPanel.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  // Helper: Anfrageliste auf Mobile öffnen + dort hin scrollen.
  // Nutzt der FAB und der Wunschartikel-Flow.
  function fwB2bExpandAndScrollToList() {
    if (cartPanel) cartPanel.setAttribute('aria-expanded', 'true');
    setTimeout(() => {
      cartPanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }

  // ── Mobile Floating-Action-Button: zur Anfrageliste springen ───────────
  document.getElementById('fwB2bMobileListFab')?.addEventListener('click', fwB2bExpandAndScrollToList);

  // ── Volltext-Suche über alle Collection-Produkte ──────────────────────
  // Aktuelles Listing zeigt nur die Pagination-Seite (25 Produkte). Damit
  // der User auch Produkte auf anderen Seiten findet, holen wir beim Init
  // einmal die komplette Collection als JSON via Shopify Storefront API.
  // Bei aktiver Suche wird das Server-Listing ausgeblendet und durch eine
  // clientseitig gerenderte Trefferliste ersetzt.

  // Such-Normalisierung: lowercase + Diakritika entfernen + ß→ss.
  // So matcht "container" auch "Cöntainer", "wuenschen" matcht "wünschen" etc.
  // Wird beim Index-Bau (einmal pro Produkt) UND beim Suchen (einmal pro Eingabe) verwendet.
  function fwNormalizeForSearch(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')   // Combining-Marks (Umlaute, Akzente) entfernen
      .replace(/ß/g, 'ss');         // ß → ss
  }

  let fwAllProductsCache = null;
  let fwAllProductsPromise = null;

  // Filter aktiv? Erkenne `filter.*=`-Parameter in der URL.
  function fwHasActiveFilter() {
    const url = new URL(window.location.href);
    for (const k of url.searchParams.keys()) {
      if (k.startsWith('filter.')) return true;
    }
    return false;
  }

  // Die IDs aller Produkte, die der aktuelle Filter durchlässt.
  // Geholt via Section-Render-API über alle Pages (Pagination), gecached
  // über die Such-Query als Key. Cache wird beim Filter-Update invalidiert.
  let fwFilteredIdsCache = null;
  let fwFilteredIdsCacheKey = null;
  let fwFilteredIdsPromise = null;

  async function fwGetFilteredProductIds() {
    if (!fwHasActiveFilter()) return null;
    const key = window.location.search;
    if (fwFilteredIdsCache && fwFilteredIdsCacheKey === key) return fwFilteredIdsCache;
    if (fwFilteredIdsPromise) return fwFilteredIdsPromise;

    const t0 = performance.now();
    fwFilteredIdsPromise = (async () => {
      const ids = new Set();
      const params = new URLSearchParams(window.location.search);
      params.set('section_id', 'fw_b2b_main-collection-products');
      let lastPageSize = 0;

      for (let page = 1; page <= 20; page++) {
        params.set('page', page);
        const res = await fetch(`${window.location.pathname}?${params.toString()}`);
        if (!res.ok) break;
        const html = await res.text();
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;
        const found = [...tmpl.content.querySelectorAll('.fw-b2b-row.js-pagination-result[data-product-id]')]
          .map(el => parseInt(el.dataset.productId, 10))
          .filter(Boolean);
        if (found.length === 0) break;
        found.forEach(id => ids.add(id));
        // Wenn weniger als die vorherige Page geliefert wurde, war es die letzte
        if (page > 1 && found.length < lastPageSize) break;
        lastPageSize = found.length;
      }
      fwFilteredIdsCache = ids;
      fwFilteredIdsCacheKey = key;
      const ms = (performance.now() - t0).toFixed(0);
      console.log(`[fw-b2b] Filter: ${ids.size} Produkt-IDs aus aktiver Filter-View (${ms} ms)`);
      return ids;
    })().catch(err => {
      console.error('[fw-b2b] Konnte Filter-IDs nicht laden:', err);
      fwFilteredIdsPromise = null;
      return null;
    }).finally(() => { fwFilteredIdsPromise = null; });

    return fwFilteredIdsPromise;
  }

  async function fwLoadAllProducts() {
    if (fwAllProductsCache) return fwAllProductsCache;
    if (fwAllProductsPromise) return fwAllProductsPromise;
    const handle = window.fwCollectionHandle;
    if (!handle) return null;

    const t0 = performance.now();
    fwAllProductsPromise = (async () => {
      const all = [];
      // Shopify-JSON-API limitiert auf 250 pro Page. Bei 352+ Produkten brauchen wir mehrere Calls.
      for (let page = 1; page <= 20; page++) {
        const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) break;
        const data = await res.json();
        const products = data.products || [];
        if (products.length === 0) break;
        for (const p of products) {
          // Nur was wir wirklich brauchen behalten — spart Speicher und macht Suche schneller
          const productImage = p.images?.[0]?.src || '';
          // Vorberechneter, normalisierter Such-Index pro Produkt:
          // Title + alle Variant-SKUs. Vendor/Tags/Variant-Titles sind absichtlich
          // RAUS, weil sie zu unscharfe Treffer erzeugen (z.B. matcht ein Tag
          // "Container" alle Fässer mit Container-Tagging, obwohl der User
          // einen IBC-Container suchte). Die werden über die Server-Filter abgedeckt.
          const skusArr = (p.variants || []).map(v => v.sku || '').filter(Boolean);
          const searchIndex = fwNormalizeForSearch([p.title || '', ...skusArr].join(' '));

          all.push({
            id: p.id,
            title: p.title || '',
            handle: p.handle,
            url: '/products/' + p.handle,
            image: productImage,
            // Options-Definitionen für die Variant-Buttons (welche Option hat mehrere Werte?)
            options: (p.options || []).map(o => ({ name: o.name, position: o.position, values: o.values || [] })),
            variants: (p.variants || []).map(v => ({
              id: v.id,
              title: v.title || '',
              sku: v.sku || '',
              option1: v.option1, option2: v.option2, option3: v.option3,
              image: v.featured_image?.src || productImage,
              // JSON-API gibt price als Float-String "10.99" → in Cents umrechnen
              priceCents: Math.round(parseFloat(v.price || '0') * 100)
            })),
            sku: skusArr[0] || '',
            // Vorberechneter, normalisierter Such-String — siehe fwNormalizeForSearch
            _idx: searchIndex
          });
        }
        if (products.length < 250) break;
      }
      fwAllProductsCache = all;
      const ms = (performance.now() - t0).toFixed(0);
      const kb = (JSON.stringify(all).length / 1024).toFixed(0);
      console.log(`[fw-b2b] Suche: ${all.length} Produkte geladen (${kb} KB, ${ms} ms)`);
      return all;
    })().catch(err => {
      console.error('[fw-b2b] Konnte Produkte für Suche nicht laden:', err);
      fwAllProductsPromise = null;
      return null;
    });
    return fwAllProductsPromise;
  }

  // Shopify-CDN-Bild auf gewünschte Breite skalieren — ?v=… bleibt erhalten,
  // ?width=N wird angehängt (oder kombiniert), spart erheblich Bandbreite.
  function fwImgSize(url, width) {
    if (!url) return '';
    return url.includes('?') ? `${url}&width=${width}` : `${url}?width=${width}`;
  }

  // Variant-Labels berechnen (gleiche Logik wie das Liquid im Server-Listing):
  // - btn_label: nur die Werte der Optionen mit mehreren Ausprägungen, z.B. "7" wenn nur "Größe" variiert
  // - full_label: alle Optionen mit Namen, z.B. "Farbe: Schwarz, Größe: 7" (für Anfrageliste)
  // - var_opt_names: Namen der variablen Optionen, z.B. "Größe" (Header über Buttons)
  function fwBuildVariantLabels(p) {
    const opts = p.options || [];
    const variableIdx = []; // 0-basierte Indizes der Optionen mit > 1 Wert
    const varOptNames = [];
    opts.forEach((o, i) => {
      if ((o.values || []).length > 1) { variableIdx.push(i); varOptNames.push(o.name); }
    });
    const variants = p.variants.map(v => {
      const optVals = [v.option1, v.option2, v.option3];
      const btnLabel = variableIdx.map(i => optVals[i]).filter(Boolean).join(' / ');
      const fullLabel = opts
        .map((o, i) => optVals[i] ? `${o.name}: ${optVals[i]}` : null)
        .filter(Boolean)
        .join(', ');
      return { ...v, btnLabel: btnLabel || v.title, fullLabel };
    });
    return { variants, varOptNames: varOptNames.join(' / ') };
  }

  // Wunschartikel-Card — selbe Struktur wie das Liquid-Pendant im Server-Listing.
  // Wird am Ende jeder Search-Result-Liste eingefügt, damit User auch in der
  // Suche eine Anfrage für nicht-gelistete Artikel starten können.
  function fwBuildFreePromptCard() {
    return `
      <div class="fw-b2b-row fw-b2b-row--free-prompt">
        <div class="fw-b2b-free-prompt__inner">
          <div class="fw-b2b-free-prompt__icon">+</div>
          <div class="fw-b2b-free-prompt__text">
            <div class="fw-b2b-free-prompt__title">Sie suchen einen Artikel, der nicht gelistet ist?</div>
            <div class="fw-b2b-free-prompt__desc">Fügen Sie einen Wunschartikel zu Ihrer Anfrageliste hinzu — Name und Menge können Sie anschließend bearbeiten.</div>
          </div>
          <button type="button" class="fw-b2b-free-prompt__btn" onclick="fwAddFreeArticle()">
            + Wunschartikel anfragen
          </button>
        </div>
      </div>`;
  }

  function fwBuildSearchResultCard(p) {
    if (!p.variants || p.variants.length === 0) return '';
    const { variants, varOptNames } = fwBuildVariantLabels(p);
    const v0 = variants[0];

    // Card-Bild: 60×60 angezeigt → Retina ~120; Anfrageliste-Item ist 44×44 → 120 ist auch da ausreichend
    const cardImgUrl = fwImgSize(p.image, 120);
    const v0ImgUrl = fwImgSize(v0.image || p.image, 120);

    const img = cardImgUrl
      ? `<img class="fw-b2b-row__image" src="${cardImgUrl}" alt="${fwEscapeHtml(p.title)}" width="60" height="60" loading="lazy">`
      : `<div class="fw-b2b-row__image fw-b2b-row__no-image">Kein Bild</div>`;

    let variantBtns = '';
    if (variants.length > 1) {
      const labelHtml = varOptNames
        ? `<span class="fw-b2b-row__variant-label">${fwEscapeHtml(varOptNames)}:</span>`
        : '';
      variantBtns = `
        <div class="fw-b2b-row__variant-btns">
          ${labelHtml}
          ${variants.map((v, i) => `
            <button class="fw-b2b-variant-btn${i === 0 ? ' active' : ''}"
                    data-product-id="${p.id}"
                    data-variant-id="${v.id}"
                    data-sku="${fwEscapeHtml(v.sku)}"
                    data-variant-title="${fwEscapeHtml(v.title)}"
                    data-variant-label="${fwEscapeHtml(v.fullLabel)}"
                    data-price-cents="${v.priceCents || 0}"
                    data-image="${fwImgSize(v.image || p.image, 120)}">
              ${fwEscapeHtml(v.btnLabel)}
            </button>`).join('')}
        </div>`;
    }

    // Detail-Row direkt unter der Card — wird beim Klick auf Expand-Button per AJAX gefüllt
    return `
      <div class="fw-b2b-row fw-b2b-search-result-row" data-product-id="${p.id}" data-variant-id="${v0.id}">
        <div class="fw-b2b-row__image-col">
          <a href="${p.url}">${img}</a>
          <button class="fw-b2b-expand-btn" data-handle="${p.handle}" data-product-id="${p.id}" aria-expanded="false" aria-label="Details anzeigen">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
        </div>
        <div class="fw-b2b-row__info">
          <a href="${p.url}" class="fw-b2b-row__title">${fwEscapeHtml(p.title)}</a>
          <div class="fw-b2b-row__meta">
            <span class="fw-b2b-row__sku">${fwEscapeHtml(v0.sku)}</span>
          </div>
          ${variantBtns}
        </div>
        <div class="fw-b2b-row__actions">
          <div class="fw-b2b-qty">
            <button type="button" class="fw-b2b-qty__btn" data-dir="minus">−</button>
            <input type="number" class="fw-b2b-qty__input" value="1" min="1" step="1" data-product-id="${p.id}">
            <button type="button" class="fw-b2b-qty__btn" data-dir="plus">+</button>
          </div>
          <button class="btn btn--primary fw-b2b-wish-btn fwInteractive"
                  data-product-id="${p.id}"
                  data-variant-id="${v0.id}"
                  data-sku="${fwEscapeHtml(v0.sku)}"
                  data-product-title="${fwEscapeHtml(p.title)}"
                  data-variant-title="${fwEscapeHtml(v0.title)}"
                  data-image="${v0ImgUrl}"
                  data-variant-label="${fwEscapeHtml(v0.fullLabel)}"
                  data-price-cents="${v0.priceCents || 0}">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
            Anfragen
          </button>
        </div>
      </div>
      <div class="fw-b2b-detail-row fw-b2b-search-detail-row" hidden>
        <div class="fw-b2b-detail-content"></div>
      </div>`;
  }

  const searchInput = document.getElementById('fwB2bSearch');
  const searchCount = document.getElementById('fwB2bSearchCount');
  // Diese Elemente werden vom facet-filter-Update via innerHTML-Replace ausgetauscht.
  // Daher NIE cachen — immer frisch via getElementById holen.
  const fwGetOriginalList = () => document.getElementById('fwB2bProductList');
  const fwGetSearchResultsEl = () => document.getElementById('fwB2bSearchResults');

  // primary: Treffer innerhalb der aktiven Filter-Auswahl
  // secondary: Treffer außerhalb des Filters — nur gerendert, wenn primary
  // dünn ist (≤3) und secondary > 0. Dazwischen kommt eine Trennlinie + Header.
  // Wunschartikel-Card wird wie im Server-Listing nach Position 5 eingefügt
  // (oder am Ende, wenn die Liste kürzer ist).
  function fwRenderSearchResults(primary, secondary, term) {
    const el = fwGetSearchResultsEl();
    if (!el) return;

    let html = '';
    let cardCounter = 0;          // zählt alle gerenderten Produkt-Cards (primary + secondary)
    let freePromptInserted = false;
    const maybeInsertFreePrompt = () => {
      if (!freePromptInserted && cardCounter === 4) {
        html += fwBuildFreePromptCard();
        freePromptInserted = true;
      }
    };

    // Primary
    for (const p of primary) {
      maybeInsertFreePrompt();
      html += fwBuildSearchResultCard(p);
      cardCounter++;
    }

    // Übergang von primary → secondary
    if (secondary.length > 0) {
      maybeInsertFreePrompt();
      if (primary.length === 0) {
        // Kein einziger Treffer im aktiven Filter → genauso deutlich wie der
        // 0-Treffer-Empty-State, damit man die Filter-Inkompatibilität klar sieht.
        html += `
          <div class="fw-b2b-search-empty">
            <div class="fw-b2b-search-empty__icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                <line x1="8" y1="11" x2="14" y2="11"/>
              </svg>
            </div>
            <div class="fw-b2b-search-empty__title">Keine Treffer für „${fwEscapeHtml(term)}" im aktiven Filter</div>
            <div class="fw-b2b-search-empty__hint">Hier finden Sie ${secondary.length === 1 ? 'einen weiteren Treffer' : `${secondary.length} weitere Treffer`} zu Ihrer Suche außerhalb des Filters:</div>
          </div>`;
      } else {
        // primary > 0 (1–3 Treffer): dezente Trennlinie + Header reicht aus
        html += `
          <div class="fw-b2b-search-secondary">
            <div class="fw-b2b-search-secondary__header">Wenige Produkte zur Filter-/Suchkombination — hier weitere Treffer zu Ihrer Suche:</div>
          </div>`;
      }
      for (const p of secondary) {
        maybeInsertFreePrompt();
        html += fwBuildSearchResultCard(p);
        cardCounter++;
      }
    }

    // 0 Treffer (kein primary, kein secondary)
    if (primary.length === 0 && secondary.length === 0) {
      html += `
        <div class="fw-b2b-search-empty">
          <div class="fw-b2b-search-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              <line x1="8" y1="11" x2="14" y2="11"/>
            </svg>
          </div>
          <div class="fw-b2b-search-empty__title">Keine Treffer für „${fwEscapeHtml(term)}"</div>
          <div class="fw-b2b-search-empty__hint">Versuchen Sie es mit anderen Suchbegriffen oder fordern Sie das Produkt unten als Wunschartikel an.</div>
        </div>`;
    }

    // Fallback: weniger als 5 Cards insgesamt → Wunschartikel-Card ans Ende
    if (!freePromptInserted) {
      html += fwBuildFreePromptCard();
    }

    el.innerHTML = html;
    el.style.display = '';
    const list = fwGetOriginalList();
    if (list) list.style.display = 'none';
    // Pagination während Suche ausblenden — die Treffer sind selbst die Liste
    document.querySelectorAll('#filter-results .pagination, custom-pagination > .pagination').forEach(elx => elx.style.display = 'none');
    fwB2bSyncWishlistState();
  }

  // DOM-Suche: filtert die Server-rendered Rows nach Title/SKU.
  // Wird nur als Fallback genutzt, falls die JSON-API fehlschlägt.
  function fwSearchInDom(term) {
    const sr = fwGetSearchResultsEl();
    const list = fwGetOriginalList();
    if (sr) sr.style.display = 'none';
    if (list) list.style.display = '';
    const rows = document.querySelectorAll('#fwB2bProductList .fw-b2b-row:not(.fw-b2b-row--header):not(.fw-b2b-row--free-prompt)');
    let visible = 0;
    rows.forEach(row => {
      const t = (row.querySelector('.fw-b2b-row__title')?.textContent || '').toLowerCase();
      const s = (row.querySelector('.fw-b2b-row__sku')?.textContent   || '').toLowerCase();
      const m = !term || t.includes(term) || s.includes(term);
      row.style.display = m ? '' : 'none';
      // Detail-Row mit verstecken
      const productId = row.dataset.productId;
      if (productId) {
        const detail = document.getElementById('fw-detail-' + productId);
        if (detail) detail.style.display = m ? '' : 'none';
      }
      if (m) visible++;
    });
    if (searchCount) searchCount.textContent = visible + ' Treffer';
  }

  function fwExitSearchMode() {
    const sr = fwGetSearchResultsEl();
    const list = fwGetOriginalList();
    if (sr) sr.style.display = 'none';
    if (list) list.style.display = '';
    // Versteckte DOM-Rows aus einer vorherigen DOM-Suche zurücksetzen
    document.querySelectorAll('#fwB2bProductList .fw-b2b-row, #filter-results .fw-b2b-detail-row')
      .forEach(el => { el.style.display = ''; });
    document.querySelectorAll('#filter-results .pagination, custom-pagination > .pagination').forEach(el => el.style.display = '');
    if (searchCount) searchCount.textContent = '';
  }

  // Wenn der Facet-Filter das Server-Listing neu rendert (innerHTML-Replace in
  // filter-results) ändert sich die gefilterte Produkt-Auswahl. Wir invalidieren
  // den IDs-Cache und triggern bei aktiver Suche die Suche neu — damit primary/
  // secondary-Aufteilung zur neuen Filter-Konfiguration passt.
  document.addEventListener('on:facet-filters:updated', () => {
    fwFilteredIdsCache = null;
    fwFilteredIdsCacheKey = null;
    if (searchInput && searchInput.value.trim()) {
      const list = fwGetOriginalList();
      if (list) list.style.display = 'none';
      document.querySelectorAll('#filter-results .pagination, custom-pagination > .pagination').forEach(el => el.style.display = 'none');
      // Suche mit neuer Filter-Konfiguration neu ausführen
      searchInput.dispatchEvent(new Event('input'));
    }
  });

  // Clear-Button im Suchfeld: nur sichtbar wenn ein Term drin ist; Click leert
  // das Feld und triggert das input-Event, damit fwExitSearchMode greift.
  const searchClearBtn = document.getElementById('fwB2bSearchClear');
  if (searchInput && searchClearBtn) {
    const fwToggleSearchClear = () => { searchClearBtn.hidden = !searchInput.value; };
    fwToggleSearchClear();
    searchInput.addEventListener('input', fwToggleSearchClear);
    searchClearBtn.addEventListener('click', () => {
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus();
    });
  }

  if (searchInput) {
    // Vorab im Hintergrund laden, damit bei der ersten Sucheingabe alles bereit ist
    fwLoadAllProducts();

    let searchDebounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      const rawTerm = this.value.trim();

      if (!rawTerm) { fwExitSearchMode(); return; }

      searchDebounce = setTimeout(async () => {
        const products = await fwLoadAllProducts();
        if (!products) { fwSearchInDom(rawTerm.toLowerCase()); return; }

        // Fuzzy-Match: normalisierte Tokens müssen ALLE im vorberechneten Index
        // vorkommen, in beliebiger Reihenfolge. So matcht "container 1000"
        // sowohl "1000 L IBC Container" als auch "Container 1000 L".
        const tokens = fwNormalizeForSearch(rawTerm).split(/\s+/).filter(Boolean);
        const allMatches = tokens.length === 0 ? [] : products.filter(p =>
          tokens.every(t => p._idx.includes(t))
        );

        // Kein Filter aktiv → alle Matches sind „primary"
        if (!fwHasActiveFilter()) {
          fwRenderSearchResults(allMatches, [], rawTerm);
          if (searchCount) searchCount.textContent = allMatches.length + ' Treffer';
          return;
        }

        // Filter aktiv: zuerst nur Matches in der gefilterten Liste zeigen.
        // Wenn das ≤3 sind, zusätzlich „weitere Treffer außerhalb des Filters" anhängen.
        const filteredIds = await fwGetFilteredProductIds();
        if (!filteredIds) {
          // Filter-IDs konnten nicht geladen werden → degrade graceful: alle als primary
          fwRenderSearchResults(allMatches, [], rawTerm);
          if (searchCount) searchCount.textContent = allMatches.length + ' Treffer';
          return;
        }
        const primary   = allMatches.filter(p =>  filteredIds.has(p.id));
        const secondary = primary.length <= 3
          ? allMatches.filter(p => !filteredIds.has(p.id))
          : [];

        fwRenderSearchResults(primary, secondary, rawTerm);
        if (searchCount) {
          searchCount.textContent = secondary.length > 0
            ? `${primary.length} Treffer · +${secondary.length} weitere`
            : `${primary.length} Treffer`;
        }
      }, 150);
    });
  }

  // ── Qty buttons ───────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fw-b2b-qty__btn');
    if (!btn) return;
    const input = btn.closest('.fw-b2b-qty').querySelector('.fw-b2b-qty__input');
    if (!input) return;
    const step = parseInt(input.step) || 1;
    const min = parseInt(input.min) || 1;
    let val = parseInt(input.value) || min;
    input.value = btn.dataset.dir === 'minus' ? Math.max(min, val - step) : val + step;
  });

  // ── Anfrageliste ──────────────────────────────────────────────────────
  const FW_STORAGE_KEY = 'fwB2bAnfrageliste';

  function fwAnfrageGet() {
    return JSON.parse(localStorage.getItem(FW_STORAGE_KEY) || '{}');
  }
  function fwAnfrageSet(data) {
    localStorage.setItem(FW_STORAGE_KEY, JSON.stringify(data));
  }

  // Kombiniert Produktname + Varianten-Attribut(e) zu "Name, Größe: 7" für Anzeige & Datenbank.
  // Bei Wunschartikeln nur den (vom User editierten) Titel oder Fallback-Text.
  function fwBuildDisplayName(item) {
    if (item.isFree) return item.productTitle?.trim() || '(Wunschartikel ohne Beschreibung)';
    const label = item.variantLabel || item.variantTitle || '';
    const baseName = item.productTitle || '—';
    const meaningfulVariant = label && !label.includes('Default Title');
    return meaningfulVariant ? `${baseName}, ${label}` : baseName;
  }

  function fwEscapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  }

  // Generic dataLayer-Push für GTM. Drei Events:
  // - b2b_request_product_added  → Produkt zur Anfrageliste hinzugefügt
  // - b2b_request_form_view      → Anfrage-Formular wird angezeigt
  // - b2b_request_form_submit    → Anfrage erfolgreich abgesendet (App ok + Mail raus)
  function fwTrackEvent(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...(data || {}) });
  }

  // Wird vom Wunschartikel-Card-Button aufgerufen — fügt jedes Mal einen neuen leeren Eintrag hinzu.
  window.fwAddFreeArticle = function () {
    const freeId = 'free_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
    const data = fwAnfrageGet();
    data[freeId] = {
      isFree: true,
      variantId: freeId,
      sku: '',
      productTitle: '',
      variantLabel: '',
      image: null,
      qty: 1,
      step: 1,
      offerAlternative: false
    };
    fwAnfrageSet(data);
    fwB2bUpdateWishlistPanel();
    fwTrackEvent('b2b_request_product_added', {
      variant_id: freeId,
      sku: '',
      product_title: '',
      quantity: 1,
      is_custom: true
    });

    // Auf Mobile ist die Anfrageliste oben standardmäßig zugeklappt — aufklappen,
    // sonst landet der neue Eintrag im versteckten Bereich.
    if (cartPanel) cartPanel.setAttribute('aria-expanded', 'true');

    // Neuen Eintrag fokussieren, damit User direkt loslegen kann
    setTimeout(() => {
      const newEl = document.querySelector(`.fw-b2b-wish-item__name--editable[data-free-id="${freeId}"]`);
      if (newEl) {
        newEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        newEl.focus();
      }
    }, 50);
  };

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fw-b2b-wish-btn');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const row = btn.closest('.fw-b2b-row');
    const qtyInput = row?.querySelector('.fw-b2b-qty__input');
    const qty  = parseInt(qtyInput?.value) || 1;
    const step = parseInt(qtyInput?.step)  || 1;
    const sku          = btn.dataset.sku || '';
    const productTitle = btn.dataset.productTitle || '';
    const variantTitle = btn.dataset.variantTitle || '';
    const variantLabel = btn.dataset.variantLabel || variantTitle;
    const image        = btn.dataset.image || '';
    const priceCents   = parseInt(btn.dataset.priceCents) || 0;  // Shopify gibt variant.price als Cents-Integer

    const data = fwAnfrageGet();
    let wasAdded = false;
    if (data[variantId]) {
      delete data[variantId];
    } else {
      data[variantId] = { sku, qty, step, variantId: parseInt(variantId), productTitle, variantTitle, variantLabel, image, priceCents, offerAlternative: false };
      wasAdded = true;
    }
    fwAnfrageSet(data);
    fwB2bUpdateWishlistPanel();
    fwB2bSyncWishlistState();
    if (wasAdded) {
      fwTrackEvent('b2b_request_product_added', {
        variant_id: parseInt(variantId),
        sku,
        product_title: productTitle,
        variant_title: variantTitle,
        quantity: qty,
        price: priceCents / 100,
        is_custom: false
      });
    }
  });

  // ── Wishlist panel ────────────────────────────────────────────────────
  window.fwB2bUpdateWishlistPanel = function () {
    const data = fwAnfrageGet();
    const keys = Object.keys(data).reverse();
    const countEl = document.getElementById('fwB2bWishCount');
    const itemsEl = document.getElementById('fwB2bWishItems');
    const actionsEl = document.getElementById('fwB2bWishActions');
    const fabCountEl = document.getElementById('fwB2bMobileListFabCount');
    if (countEl) countEl.textContent = keys.length;
    if (fabCountEl) {
      fabCountEl.textContent = keys.length;
      fabCountEl.setAttribute('data-count', keys.length);
    }
    // Header-Counter (#fwWishlistCount + Icon-Farbe) mit gleicher Quelle synchronisieren —
    // beide Stores arbeiten auf localStorage 'fwB2bAnfrageliste'.
    if (typeof fwAnfrageUpdateCount === 'function') fwAnfrageUpdateCount();
    if (!itemsEl) return;

    if (keys.length === 0) {
      itemsEl.innerHTML = '<div class="fw-b2b-cart-empty">Ihre Anfrageliste ist leer.</div>';
      if (actionsEl) actionsEl.style.display = 'none';
      return;
    }

    itemsEl.innerHTML = keys.map(vid => {
      const item = data[vid];

      if (item.isFree) {
        return `
          <div class="fw-b2b-wish-item fw-b2b-wish-item--free" data-variant-id="${vid}">
            <div class="fw-b2b-wish-item__img">
              <div class="fw-b2b-wish-item__free-icon"><img src="https://cdn.shopify.com/s/files/1/0787/0513/1846/files/FW_Produktliste.svg?v=1768894840" alt="" loading="lazy"></div>
            </div>
            <div class="fw-b2b-wish-item__body">
              <div class="fw-b2b-wish-item__header">
                <span class="fw-b2b-wish-item__name fw-b2b-wish-item__name--editable"
                      contenteditable="true"
                      data-placeholder="Beschreibung anklicken & eingeben"
                      data-free-id="${vid}">${fwEscapeHtml(item.productTitle || '')}</span>
                <button class="fw-b2b-wish-remove" data-variant-id="${vid}" aria-label="Entfernen">×</button>
              </div>
              <span class="fw-b2b-wish-item__free-badge">Wunschartikel</span>
              <div class="fw-b2b-wish-item__footer">
                <div class="fw-b2b-wish-qty">
                  <button type="button" class="fw-b2b-wish-qty__btn" data-dir="minus" data-variant-id="${vid}">−</button>
                  <input type="number" class="fw-b2b-wish-qty__input" value="${item.qty}" min="1" step="${item.step || 1}" data-variant-id="${vid}">
                  <button type="button" class="fw-b2b-wish-qty__btn" data-dir="plus" data-variant-id="${vid}">+</button>
                </div>
                <label class="fw-b2b-wish-item__alt">
                  <input type="checkbox" data-variant-id="${vid}" ${item.offerAlternative ? 'checked' : ''}>
                  Alternative anbieten
                </label>
              </div>
            </div>
          </div>`;
      }

      return `
        <div class="fw-b2b-wish-item" data-variant-id="${vid}">
          <div class="fw-b2b-wish-item__img">
            ${item.image ? `<img src="${item.image}" alt="${item.productTitle}" width="44" height="44" loading="lazy">` : ''}
          </div>
          <div class="fw-b2b-wish-item__body">
            <div class="fw-b2b-wish-item__header">
              <span class="fw-b2b-wish-item__name">${fwBuildDisplayName(item)}</span>
              <button class="fw-b2b-wish-remove" data-variant-id="${vid}" aria-label="Entfernen">×</button>
            </div>
            <span class="fw-b2b-wish-item__sku">${item.sku || vid}</span>
            <div class="fw-b2b-wish-item__footer">
              <div class="fw-b2b-wish-qty">
                <button type="button" class="fw-b2b-wish-qty__btn" data-dir="minus" data-variant-id="${vid}">−</button>
                <input type="number" class="fw-b2b-wish-qty__input" value="${item.qty}" min="1" step="${item.step || 1}" data-variant-id="${vid}">
                <button type="button" class="fw-b2b-wish-qty__btn" data-dir="plus" data-variant-id="${vid}">+</button>
              </div>
              <label class="fw-b2b-wish-item__alt">
                <input type="checkbox" data-variant-id="${vid}" ${item.offerAlternative ? 'checked' : ''}>
                Alternative anbieten
              </label>
            </div>
          </div>
        </div>`;
    }).join('');

    // Click-to-edit auf Wunschartikel-Titel: speichert in localStorage bei Eingabe
    itemsEl.querySelectorAll('.fw-b2b-wish-item__name--editable').forEach(el => {
      el.addEventListener('input', function () {
        const vid = this.dataset.freeId;
        const d = fwAnfrageGet();
        if (d[vid]) {
          d[vid].productTitle = this.textContent.trim();
          fwAnfrageSet(d);
        }
        // Bei Tippen: ggf. die Fehlermeldung über dem Absenden-Button ausblenden
        const errorEl = document.getElementById('fwB2bWishError');
        if (errorEl && !errorEl.hidden) errorEl.hidden = true;
      });
      // Reichen Text-Paste durch, Rich-HTML strippen
      el.addEventListener('paste', function (e) {
        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text');
        document.execCommand('insertText', false, text);
      });
      // Enter beendet Editier-Modus statt Zeilenumbruch
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); this.blur(); }
      });
      // Beim Verlassen des Feldes kurz grün aufblitzen → Bestätigung „gespeichert"
      el.addEventListener('blur', function () {
        this.classList.remove('fw-name-saved');
        // Browser zwingen, die Animation neu zu starten (sonst kein Effekt bei wiederholtem Blur)
        void this.offsetWidth;
        this.classList.add('fw-name-saved');
        setTimeout(() => this.classList.remove('fw-name-saved'), 1200);
      });
    });

    // Remove buttons
    itemsEl.querySelectorAll('.fw-b2b-wish-remove').forEach(btn => {
      btn.addEventListener('click', function () {
        const d = fwAnfrageGet();
        delete d[this.dataset.variantId];
        fwAnfrageSet(d);
        fwB2bUpdateWishlistPanel();
        fwB2bSyncWishlistState();
      });
    });

    // Qty buttons in panel
    itemsEl.querySelectorAll('.fw-b2b-wish-qty__btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const vid = this.dataset.variantId;
        const input = itemsEl.querySelector(`.fw-b2b-wish-qty__input[data-variant-id="${vid}"]`);
        const d = fwAnfrageGet();
        if (!input || !d[vid]) return;
        const step = parseInt(input.step) || 1;
        const min  = parseInt(input.min)  || 1;
        let val = parseInt(input.value) || min;
        val = this.dataset.dir === 'minus' ? Math.max(min, val - step) : val + step;
        input.value = val;
        d[vid].qty = val;
        fwAnfrageSet(d);
        if (countEl) countEl.textContent = Object.keys(fwAnfrageGet()).length;
      });
    });

    // Qty input direct edit
    itemsEl.querySelectorAll('.fw-b2b-wish-qty__input').forEach(input => {
      input.addEventListener('change', function () {
        const d = fwAnfrageGet();
        if (!d[this.dataset.variantId]) return;
        d[this.dataset.variantId].qty = Math.max(1, parseInt(this.value) || 1);
        this.value = d[this.dataset.variantId].qty;
        fwAnfrageSet(d);
      });
    });

    // Alternative-anbieten checkboxes
    itemsEl.querySelectorAll('.fw-b2b-wish-item__alt input').forEach(cb => {
      cb.addEventListener('change', function () {
        const d = fwAnfrageGet();
        if (d[this.dataset.variantId]) {
          d[this.dataset.variantId].offerAlternative = this.checked;
          fwAnfrageSet(d);
        }
      });
    });

    if (actionsEl) actionsEl.style.display = '';
  };

  document.getElementById('fwB2bClearWishlist')?.addEventListener('click', () => {
    localStorage.removeItem(FW_STORAGE_KEY);
    fwB2bUpdateWishlistPanel();
    fwB2bSyncWishlistState();
  });

  document.getElementById('fwB2bSendWishlist')?.addEventListener('click', fwOpenAnfrageModal);

  // ── Anfrage Modal ─────────────────────────────────────────────────────
  // Die Modal-Logik liegt im geteilten Modul assets/fw__js-anfrage-modal.js
  // (window.fwAnfrageModal), das auch die PDP nutzt. Hier nur noch der
  // B2B-spezifische Aufruf inkl. Wunschartikel-Validierung.
  function fwOpenAnfrageModal() {
    // Vor dem Öffnen: leere Wunschartikel finden — Modal nicht öffnen, sondern
    // auf den Sidebar-Eintrag scrollen, damit der User die Beschreibung ergänzt.
    const validateData = fwAnfrageGet();
    const emptyFree = Object.entries(validateData).find(([, it]) => it.isFree && !(it.productTitle || '').trim());
    const errorEl = document.getElementById('fwB2bWishError');
    if (emptyFree) {
      if (errorEl) errorEl.hidden = false;
      const target = document.querySelector(`.fw-b2b-wish-item__name--editable[data-free-id="${emptyFree[0]}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.focus();
        target.style.boxShadow = '0 0 0 3px #ef4444';
        setTimeout(() => { target.style.boxShadow = ''; }, 2500);
      }
      return;
    }
    if (errorEl) errorEl.hidden = true;

    if (!window.fwAnfrageModal) { console.error('fwAnfrageModal-Modul nicht geladen'); return; }
    window.fwAnfrageModal.open({
      mode: 'b2b',
      subject: 'Angebotsanfrage',
      title: 'Angebotsanfrage',
      getItems: () => Object.values(fwAnfrageGet()).reverse(),
      updateItem: (variantId, patch) => {
        const d = fwAnfrageGet();
        const key = String(variantId);
        if (!d[key]) return;
        Object.assign(d[key], patch);
        fwAnfrageSet(d);
        fwB2bUpdateWishlistPanel();   // Sidebar-Panel synchron halten
      },
      removeItem: (variantId) => {
        // Loescht das Item aus dem Storage UND aktualisiert die B2B-Sidebar
        // (Modal-Liste wird vom Modal selbst per renderItems() neu gezeichnet).
        const d = fwAnfrageGet();
        delete d[String(variantId)];
        fwAnfrageSet(d);
        fwB2bUpdateWishlistPanel();
      },
      onSuccess: () => {
        localStorage.removeItem(FW_STORAGE_KEY);
        fwB2bUpdateWishlistPanel();
        fwB2bSyncWishlistState();
      },
      showAddMore: false
    });
  }

  function fwB2bSyncWishlistState() {
    const data = fwAnfrageGet();
    document.querySelectorAll('.fw-b2b-wish-btn').forEach(btn => {
      btn.classList.toggle('fw-b2b-wish-btn--active', !!data[btn.dataset.variantId]);
    });
  }

  // ── Quick Add by SKU ──────────────────────────────────────────────────
  async function fwB2bQuickAdd() {
    const input = document.getElementById('fwB2bSkuInput');
    const addBtn = document.getElementById('fwB2bSkuAdd');
    const sku = input?.value.trim();
    if (!sku) return;
    addBtn.disabled = true;
    addBtn.textContent = '…';
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(sku)}&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku`);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) throw new Error('not found');
      const product = products[0];
      const variantId = product.variants?.[0]?.id;
      if (!variantId) throw new Error('no variant');
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      addBtn.textContent = '✓';
      input.value = '';
      fwB2bLoadCart();
      setTimeout(() => { addBtn.disabled = false; addBtn.textContent = 'Add'; }, 1500);
    } catch {
      addBtn.textContent = '–';
      setTimeout(() => { addBtn.disabled = false; addBtn.textContent = 'Add'; }, 1500);
    }
  }

  document.getElementById('fwB2bSkuInput')?.addEventListener('keydown', e => { if (e.key === 'Enter') fwB2bQuickAdd(); });
  document.getElementById('fwB2bSkuAdd')?.addEventListener('click', fwB2bQuickAdd);

  // ── Letzte Bestellung ─────────────────────────────────────────────────
  // window.fwIsCustomer wird in der .liquid-Datei vor dem Laden dieses Scripts gesetzt.
  document.getElementById('fwB2bLastOrder')?.addEventListener('click', () => {
    window.location.href = window.fwIsCustomer ? '/account' : '/account/login';
  });

  // ── Init ──────────────────────────────────────────────────────────────
  fwB2bUpdateWishlistPanel();
  fwB2bSyncWishlistState();

  // ── Variant selector ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fw-b2b-variant-btn');
    if (!btn) return;

    // Toggle active state
    btn.closest('.fw-b2b-row__variant-btns').querySelectorAll('.fw-b2b-variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Update SKU display — innerhalb der Row suchen, damit es auch in
    // Search-Result-Cards funktioniert (deren Row hat keine fw-sku-{id} ID).
    const row = btn.closest('.fw-b2b-row');
    const skuEl = row?.querySelector('.fw-b2b-row__sku');
    if (skuEl) skuEl.textContent = btn.dataset.sku;

    // Update Anfragen button data
    const wishBtn = row?.querySelector('.fw-b2b-wish-btn');
    if (wishBtn) {
      wishBtn.dataset.variantId    = btn.dataset.variantId;
      wishBtn.dataset.sku          = btn.dataset.sku;
      wishBtn.dataset.variantTitle = btn.dataset.variantTitle;
      wishBtn.dataset.variantLabel = btn.dataset.variantLabel;
      wishBtn.dataset.image        = btn.dataset.image;
      wishBtn.dataset.priceCents   = btn.dataset.priceCents || '';
    }

    // Sync active/inactive state of Anfragen button
    fwB2bSyncWishlistState();
  });

  // ── Detail image thumbnails (delegated — content loaded async via innerHTML) ──
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.fw-b2b-detail__thumb');
    if (!thumb) return;
    const img = document.getElementById(thumb.dataset.target);
    if (img) img.src = thumb.dataset.src;
    thumb.closest('.fw-b2b-detail__thumbs').querySelectorAll('.fw-b2b-detail__thumb').forEach(b => b.classList.remove('active'));
    thumb.classList.add('active');
  });

  // ── Product detail expand ─────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fw-b2b-expand-btn');
    if (!btn) return;

    const productId = btn.dataset.productId;
    const handle = btn.dataset.handle;
    // Detail-Row finden: zuerst als nextElementSibling der Row (für Search-Cards),
    // sonst über die globale ID (Server-Listing). So funktionieren beide Layouts.
    const row = btn.closest('.fw-b2b-row');
    let detailRow = row?.nextElementSibling;
    if (!detailRow?.classList?.contains('fw-b2b-detail-row')) {
      detailRow = document.getElementById('fw-detail-' + productId);
    }
    if (!detailRow) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      btn.setAttribute('aria-expanded', 'false');
      detailRow.hidden = true;
      return;
    }

    btn.setAttribute('aria-expanded', 'true');
    detailRow.hidden = false;

    const content = detailRow.querySelector('.fw-b2b-detail-content');
    if (content.dataset.loaded) return;

    content.innerHTML = '<div class="fw-b2b-detail-loading">Wird geladen…</div>';

    fetch('/products/' + handle + '?section_id=fw_b2b_main-collection-product-details')
      .then(r => r.text())
      .then(html => {
        content.innerHTML = html;
        content.dataset.loaded = '1';
      })
      .catch(() => {
        content.innerHTML = '<div class="fw-b2b-detail-loading">Fehler beim Laden.</div>';
      });
  });

  // Force active-filter chips always visible in B2B sidebar
  function fwB2bOpenActiveFilters() {
    const details = document.querySelector('.fw-b2b-sidebar .facets__active-filters details');
    if (details) details.setAttribute('open', '');
  }
  fwB2bOpenActiveFilters();
  document.addEventListener('on:facet-filters:updated', fwB2bOpenActiveFilters);
});
